import React, { useEffect } from 'react';
import css from '@features/thank-you/styles/ThankyouV3.module.css';
import { SuccessRoundedTick } from '@shared/assets/svgs/SuccessRoundedTick';
import { banners } from '@shared/config/constants/Banners';
import { useTranslation } from 'react-i18next';
import { isRTL, redirectToStore } from '@shared/utils/general';
import { isIOS, isMacOs } from 'react-device-detect';
import { useAtomValue } from 'jotai';
import { useQuery, useWideLayout } from '@shared/hooks';
import { Header, HeaderTV } from '@shared/ui/header';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { changeLandingPageView } from '@shared/store/slices/global.actions';
import { hungamaCointriesList } from '@shared/ui/logo/model/utils';
import Icons from '@shared/config/constants/Icons';
import VUZLinearLogo from '@shared/assets/svgs/VUZLinearlogo';
import { dcbAtom, languageAtom } from '@shared/store/slice-atoms';
import { isID } from '@entities/country';

const ThankyouV3 = ({ languageConfig = {}, activationURL = null, showOpenButton = false }) => {
  const { t } = useTranslation();

  const history = useHistory();
  const { query } = useQuery();
  const { isTVLayout } = useWideLayout();

  const dcb = useAtomValue(dcbAtom);
  const language = useAtomValue(languageAtom);
  const { direction, locale } = language;
  const { homeData, isInapp } = dcb as any;

  const isRTLDirection = isRTL(direction);
  const shouldShowOpenButton = showOpenButton && Boolean(activationURL);
  // NOTE: Hide App Store / Google Play badges for Indonesia
  const hideStoreLinks = isID(homeData?.country) || locale === 'id';

  useEffect(() => {
    changeLandingPageView('');
  }, []);

  const shouldRenderSecondaryLogo = hungamaCointriesList[homeData?.country?.toUpperCase()];

  const handleInappSuccessReload = () => {
    const isStatusParamAlreadyExists = query.get('status') || '';

    if (isStatusParamAlreadyExists) return;

    history.push({
      pathname: window.location.pathname,
      search: '?status=success',
    });
  };

  return (
    <div style={{ height: '100vh', position: 'relative', paddingTop: isInapp ? '48px' : 0 }}>
      {isInapp ? (
        <div
          className="inapp-close-cross-container"
          style={{
            right: isRTLDirection ? 'unset' : '16px',
            left: isRTLDirection ? '16px' : 'unset',
          }}
          onClick={handleInappSuccessReload}
        >
          <img src={Icons.exit} width={24} height={24} alt="cross ic" />
        </div>
      ) : null}

      {isTVLayout ? <HeaderTV /> : <Header renderLogo={shouldRenderSecondaryLogo} languageConfig={languageConfig} />}

      <div className={css.cover}>
        {!isTVLayout ? (
          <div className={css.linearLogo}>
            <VUZLinearLogo />
          </div>
        ) : null}

        <img
          className={cn(css.mainBanner, isTVLayout ? css.mainBannerWide : '')}
          src={banners.success_subs_background}
          alt="redirect banner"
          onClick={redirectToStore}
        />

        <div className={cn(css.wrapper, isTVLayout ? css.wrapperWide : '')}>
          <div className={css.successIcon}>
            <SuccessRoundedTick />
          </div>

          <div className={css.title}>{t('subscribed_success')}</div>

          <div className={css.description}>{t('largest_library_access')}</div>
          {shouldShowOpenButton ? (
            <a
              className={css.openAppButton}
              href={activationURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('open_the_app')}
            </a>
          ) : null}
          {!isTVLayout && !isInapp && !hideStoreLinks ? (
            <>
              <div className={css.downloadVUZTitle}>{t('download_vuz_app')}</div>
              {isIOS || isMacOs ? (
                <a href={'https://apps.apple.com/us/app/360-vuz-live-vr-video-views/id964118383'}>
                  <img src={Icons.app_store_confirmation_logo} alt="app store" />
                </a>
              ) : (
                <a
                  href={
                    'https://play.google.com/store/apps/details?id=com.creativeinnovations.mea&hl=en'
                  }
                >
                  <img src={Icons.google_paly_confirmation_logo} alt="google play" />
                </a>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ThankyouV3;
